import React from 'react';

const variantClasses = {
  default: 'bg-primary text-primary-foreground border-transparent hover:bg-primary/90',
  outline: 'bg-card text-foreground border-border hover:bg-muted',
  ghost: 'bg-transparent border-transparent text-foreground hover:bg-muted',
  secondary: 'bg-secondary text-secondary-foreground border-transparent hover:bg-secondary/90',
  destructive: 'bg-destructive text-destructive-foreground border-transparent hover:bg-destructive/90',
  link: 'border-transparent bg-transparent text-primary underline-offset-4 hover:underline',
};

const sizeClasses = {
  default: 'h-10 px-4 text-sm',
  sm: 'h-9 px-3 text-sm',
  lg: 'h-11 px-8 text-sm',
  icon: 'h-10 w-10 p-0',
};

export const Button = React.forwardRef(function Button(
  { variant = 'default', size = 'default', className = '', children, type = 'button', ...rest },
  ref
) {
  const base =
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50';
  return (
    <button
      ref={ref}
      type={type}
      className={`${base} ${variantClasses[variant] || ''} ${sizeClasses[size] || ''} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
});

export default Button;
